import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.to-string.js";
export function getTabLinkFromParams(_ref) {
  var tabName = _ref.tabName,
    location = _ref.location;
  var searchParams = new URLSearchParams(location.search);
  searchParams.set('tab', tabName); // Add or update the tab parameter
  return "".concat(location.pathname, "?").concat(searchParams.toString());
}